import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import Config from "../../Util/config";
import HttpUtil from '../../Util/httpUtil';
import '../../_Content/css/EnviarArquivo.css';
import { Modal, ModalHeader, ModalBody, Row, Col, Alert, Container } from "reactstrap";
import { withRouter } from "react-router-dom";
import './EnviarArquivos.css';

//TODO OBTER VALORES DO FLUXO
const idUsuario = localStorage.getItem("CodUsuario");
const token = localStorage.getItem("Token");
const isPro = localStorage.getItem("isPro") === 'true';
const isSimulacao = localStorage.getItem("isSimulacao") === 'true';
let rawData = [];

class EnviarArquivos extends Component {

	constructor(props) {
		super(props);

		this.state = ({
			backdrop: true,
			status: "",
			indexArquivoUpload: 0,
			qtdeTotal: 0,
			pcentUpload: 0,
			pcentTotal: 0,
			progressEventLoaded: 0,
			progressEventTotal: 0,
			progressEvents: [],
			dropzoneStatus: isPro || isSimulacao ? "inactive" : "active",
			modal: this.props.propModalUpload,
			qtdePermitida: null,
			exibirErroQtde: false,
			exibirErroArquivo: false,
			mensErroArquivo: "",
			showError: false
		});
	}

	validarHabilitarDZ = () => {
		this.setState({
			exibirErroQtde: false,
			mensErroArquivo: "",
			exibirErroArquivo: false

		});

		if (isSimulacao)
			this.setState({ dropzoneStatus: "inactive" });
		else if (isPro) {
			return new Promise((resolve, reject) => {
				let url = `${Config.urls.API_URL_BASE}HistoricoArquivos/QuantidadeArquivosPermitidos/${idUsuario}/${token}`;
				HttpUtil.eco_GET(url, response => {
					this.setState({
						qtdePermitida: response.data,
						dropzoneStatus: response.data > 0 ? "active" : "inactive",
						exibirErroQtde: response.data <= 0
					});
				},
					() => {
						console.log('Error');
					}
				);
			});
		}
	}

	iniciarUpload = (pStatus, pIndexArquivoUpload, pQtdeTotal) => {
		this.setState({
			status: pStatus,
			indexArquivoUpload: pIndexArquivoUpload,
			qtdeTotal: pQtdeTotal,
			pcentUpload: 0,
			pcentTotal: 0,
			progressEventLoaded: 0,
			progressEventTotal: 0,
			progressEvents: []
		});
	}

	addProgressEvent(newProgressEvent) {
		let arrUploads = this.state.progressEvents;
		arrUploads.push(newProgressEvent);
		this.setState({ progressEvents: arrUploads })
	}

	onDrop(acceptedFiles, rejectedFiles, isIcms, isSimples) {
		this.setState({
			dropzoneStatus: "inactive",
			exibirErroQtde: false
		});

		if (isPro && acceptedFiles.length > this.state.qtdePermitida) {
			this.setState({
				dropzoneStatus: "active",
				exibirErroQtde: true
			});
			return false;
		}

		if (rejectedFiles.length > 0) {
			let mensagem = "Existe um arquivo inválido ao enviar: '" + rejectedFiles[0].name + "'"
			if (rejectedFiles.length > 1) {
				mensagem = "Existem arquivos inválidos ao enviar: "
				for (var i in rejectedFiles) {
					mensagem = mensagem + "'" + rejectedFiles[i].name + "', "
				}
				mensagem = mensagem.substring(0, (mensagem.length - 2))
			}

			this.setState({
				mensErroArquivo: mensagem,
				dropzoneStatus: "active",
				exibirErroArquivo: true
			});
			return false;
		}

		this.iniciarUpload("Upload", 1, acceptedFiles.length);

		acceptedFiles.forEach(formFile => {
			const configAxios = {
				headers: { 'content-type': 'multipart/form-data' },
				onUploadProgress: progressEvent => {
					if (acceptedFiles.length == 1) {
						var pcentUpload = Math.round(progressEvent.loaded * 100 / progressEvent.total);

						if (pcentUpload >= 100) {
							this.setState({
								status: "Finalizado",
								pcentUpload: 100,
								dropzoneStatus: isPro ? "inactive" : "active"
							});
						} else {
							this.setState({ pcentUpload });
						}
					}
					else {
						if (this.state.progressEvents.indexOf(JSON.stringify(formFile)) == "-1") {
							this.addProgressEvent(JSON.stringify(formFile));
							this.setState({
								progressEventTotal: this.state.progressEventTotal + progressEvent.total
							});
						}

						var pcentUploadIndex = Math.round(progressEvent.loaded * 100 / progressEvent.total);
						var indexAtual = this.state.indexArquivoUpload;
						var loaded = this.state.progressEventLoaded + progressEvent.loaded;

						console.log(indexAtual);

						if (pcentUploadIndex >= 100) {
							if (this.state.indexArquivoUpload < acceptedFiles.length + rejectedFiles.length) {
								this.setState({
									indexArquivoUpload: indexAtual + 1,
									dropzoneStatus: isPro ? "inactive" : "active"
								});
							}
							this.setState({
								progressEventLoaded: this.state.progressEventLoaded + progressEvent.loaded
							});

							console.log("finalizou arquivo "+indexAtual);
						}

						var pcentUpload = Math.round(this.state.progressEventLoaded * 100 / this.state.progressEventTotal);

						if (pcentUpload >= 100 && indexAtual >= (acceptedFiles.length + rejectedFiles.length)) {
							console.log("finalizou todos");
							this.iniciarUpload("Finalizado", 0, 0);
						}
						else if (pcentUploadIndex >= 100) {
							this.setState({
								progressEventLoaded: this.state.progressEventLoaded + progressEvent.loaded
							});
						}

						this.setState({
							pcentUpload
						});
					}
				}
			};

			const executarUpload = (formFile, isIcms, isSimples) => {
				return new Promise((resolve, reject) => {
					let formData = new FormData();
					formData.append('file', formFile);
					formData.append('hash', JSON.stringify(formFile)); //TODO - Pegar hash do form

					var urlApi = Config.urls.API_URL_BASE + "Upload/PostFormData/" + idUsuario;

					urlApi += token != "" ? '/' + token : "/null";
					urlApi += isSimples ? "/simples-nacional" : "/null";

					HttpUtil.eco_POST_CONFIG(urlApi, formData, configAxios, (response) => {
						rawData = response.data;

						if(!rawData.error){
							const res = {
								rows: rawData,
								isIcms: isIcms,
								isSimples: isSimples
							};
							resolve(res);
						}else{
							this.setState({errorMessage: rawData.errorMessage, showError: true})
						}
						
					}, (reject) => {
						console.log(JSON.stringify(reject));
					});
				});
			};

			executarUpload(formFile, isIcms, isSimples);
		});
	}

	redirectArquivosRecentes() {
		this.setState({ status: "" });
		this.props.history.push("/arquivos-recentes");
		this.props.fnToggleModalUpload();
	}

	setarBotaoUpload() {
		if (this.state.status == 'Upload') {
			return (
				<a className="progress eco-progress-upload baby-blue w-100 mt-4 mb-4">
					<span>Subindo {this.state.indexArquivoUpload} de {this.state.qtdeTotal} Arquivos.</span>
					<div className="progress-bar progress-bar-striped progress-bar-animated baby-blue" role="progressbar"
						aria-valuenow="87" aria-valuemin="0" aria-valuemax="100"
						style={{ width: ('' + this.state.pcentUpload + '%') }}>
					</div>
				</a>
			);
		}
		else if (this.state.status === 'Erro') {
			return (
				<button className="ecobtn fit vazado vermelho w-100 mt-4 mb-4" style={{ width: '100px' }}>Erro</button>
			);
		}
		else if (this.state.status === 'Finalizado') {
			this.redirectArquivosRecentes();
		}
		else {
			return (
				<button className="ecobtn fat vazado azul-royal w-100 mt-4 mb-4"
					onClick={(e) => this.redirectArquivosRecentes()}>Ir para os arquivos enviados
				</button>
			);
		}
	}

	openModal = () => {
		return (
			<Modal id="modal-envio" isOpen={this.props.propModalUpload} onOpened={this.validarHabilitarDZ}>
				{this.state.status !== 'Upload' &&
					<ModalHeader toggle={this.props.toggleModalUpload} onClick={this.props.fnToggleModalUpload}>
						<i className="fas fa-times"></i>
					</ModalHeader>
				}
				<ModalBody>

					{isSimulacao &&
						<div className="mensagem-envio-nao-permitido">
							<div class="alert alert-danger" role="alert">
								Modo simulação não permite enviar arquivos.
							</div>
						</div>
					}
					{this.state.exibirErroQtde &&
						<div className="mensagem-envio-nao-permitido">
							<div class="alert alert-danger" role="alert">
								Quantidade de arquivos excede o permitido para o usuário teste. (Restam {this.state.qtdePermitida})
							</div>
						</div>
					}
					{this.state.exibirErroArquivo &&
						<div className="mensagem-envio-nao-permitido">
							<div class="alert alert-danger" role="alert">
								{this.state.mensErroArquivo}
							</div>
						</div>
					}

					<section id="enviarArquivos">
						<Row>
							<Col md={{ size: 4, offset: 1 }}>
								<form>
									<Dropzone accept="text/plain"
										id="icms"
										rejectClassName="rejectStyle"
										acceptClassName="acceptStyle"
										onDrop={(accepted, rejected) => {
											this.onDrop(accepted, rejected, true, false)
										}}
										className={(this.state.dropzoneStatus === "inactive") || (this.state.status === "Upload") ? "dropUploadBt inactive" : "dropUploadBt"}
										disabled={(this.state.dropzoneStatus === "inactive") || (this.state.status === "Upload") ? true : false}>
										<img src="/img/ecoicos/ecoico-sped.svg" alt="ICMS IPI" />
									</Dropzone>
								</form>
								{/* Descomentar quando o projeto ECD for ao ar e apagar o abaixo*/}
								<h2>
									ICMS IPI / PIS COFINS / ECF / ECD
									<p>O arquivo precisa estar no formato .txt</p>
								</h2>
							</Col>
							<Col md={{ size: 2 }}>
								<span className="separator"></span>
							</Col>
							<Col md={{ size: 4 }}>
								<form>
									<Dropzone accept="text/plain"
										id="simples-nacional"
										rejectClassName="rejectStyle"
										acceptClassName="acceptStyle"
										onDrop={(accepted, rejected) => {
											this.onDrop(accepted, rejected, false, true)
										}}
										className={(this.state.dropzoneStatus === "inactive") || (this.state.status === "Upload") ? "dropUploadBt inactive" : "dropUploadBt"}
										disabled={(this.state.dropzoneStatus === "inactive") || (this.state.status === "Upload") ? true : false}>
										<img src="/img/ecoicos/ecoico-simples-nacional.svg" alt="Simples Nacional" />
									</Dropzone>
								</form>
								<h2>
									Simples Nacional
									<p>Para escrituração EFD ICMS/IPI Simples Nacional (AL, CE, MS, PA e RN) utilize
										esta opção.</p>
								</h2>
							</Col>
						</Row>
						<Row>
							<Col md={{ size: 4, offset: 4 }}>
								{this.setarBotaoUpload()}
							</Col>
						</Row>
					</section>
				</ModalBody>
			</Modal>
		)
	}

	onDismissError = () => {
		this.setState({
			showError: false
		});

	}

	render() {
		return (
			<div id="modal-enviar-arquivos">
				<div className="alert-file-error"> 
				{
					this.state.showError &&
					<Alert isOpen={this.state.showError} toggle={this.onDismissError} color="danger" className="notification">
							<Container>
								<Row>
									<Col md={2}>
										<img src="/img/ecoicos/ecoico-alerta.svg" />
									</Col>
									<Col md={10} onClick={this.redirect}>
										<p>{this.state.errorMessage}</p>
									</Col>
								</Row>
							</Container>
						</Alert>
				}
				</div>
				{this.openModal()}
			</div>
		);
	}
}

export default withRouter(EnviarArquivos);


// WEBPACK FOOTER //
// ./src/Componente/Arquivos/EnviarArquivos.jsx